import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MarketingLayout from './Layout';
import Home from './Home';
import Features from './Features';
import Security from './Security';
import Solutions from './Solutions';
import SolutionDetail from './SolutionDetail';
import Pricing from './Pricing';
import GetStarted from './GetStarted';
import Contact from './Contact';
import About from './About';
import Privacy from './Privacy';
import Terms from './Terms';
import SignIn from './SignIn';

/**
 * konklave.app used to BE Kappa's member app, so emails/links already sent carry
 * `https://konklave.app/<app path>` (surveys, profile verification, vouch,
 * events…). Any path that isn't a marketing page goes to the same path on
 * Kappa's member host, so none of those links break.
 */
const LegacyMemberAppRedirect: React.FC = () => {
  const { hostname, pathname, search, hash } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return <Navigate to="/" replace />;
  window.location.replace(`https://members.konklave.app${pathname}${search}${hash}`);
  return null;
};

/**
 * Konklave marketing site (served on the marketing hosts — see isMarketingHost).
 * Self-contained router so it stays independent of the tenant member app.
 */
const MarketingApp: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route element={<MarketingLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/security" element={<Security />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/solutions/:slug" element={<SolutionDetail />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<LegacyMemberAppRedirect />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default MarketingApp;
